import React, { Component,  } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'jquery.transit';
import * as PIXI from 'pixi.js-legacy';
import data from "../../store/projects"
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

class CaseFooterNew extends Component{
  footerImage = React.createRef();
  footerCanvas = React.createRef();

  propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  componentDidMount(){
 
    /*****/
    const size = [1920, 625];
    const speed = 4;
    let x = 5;
    let y = 5;
    let ishover = false;
    const offset = [0, 0];
    const offsetValue = 700;
    const body = this.footerCanvas.current;
    if (!body) return;
    const app = new PIXI.Application({width: size[0], height: size[1], transparent: true, antialias: true});
    this.footerApp = app;
    body.appendChild(app.view);

    app.loader.add('img', this.nextArr.imgCaseBottom?this.nextArr.imgCaseBottom: this.props.img)
    app.loader.add('filter', '/img/circlefilter.png')
      .load((loader, resources) => {
      if (this.footerApp !== app) return;
      const img = new PIXI.Sprite(resources.img.texture);
      const displacementSprite = new PIXI.Sprite(resources.filter.texture);
      displacementSprite.width = size[0];
      displacementSprite.height = size[1];
      displacementSprite.width = offsetValue;
      displacementSprite.height = offsetValue;
      const displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
      img.x = 0;
      img.y = 0;

      app.stage.filters = [displacementFilter];
      app.stage.addChild(img);
      app.stage.addChild(displacementSprite);

      app.ticker.add(() => {
        if(ishover){
          displacementSprite.x = x;
          displacementSprite.y = y;
          offset[0] = offsetValue/2;
          offset[1] = offsetValue/2;

          if(offset[0] < offsetValue/2){
            offset[0] += speed;
          }
          if(offset[1] < offsetValue/2){
            offset[1] += speed;
          }
        }
        else{
          if(x <= 0){
            displacementSprite.x += -speed;
          }
          else{
            displacementSprite.x += speed;
          }
          if(y <= 0){
            displacementSprite.y += -speed;
          }
          else{
            displacementSprite.y += speed;
          }

          if(offset[0] > 0){
            offset[0] -= speed;
          }
          if(offset[1] > 0){
            offset[1] -= speed;
          }
        }
      });
    });

    const canvas = $(this.footerImage.current);
    this.footerImageNode = canvas;
    canvas.on('mousemove.caseFooterNew', function(e){
      ishover = true;
      var _x = $(this).offset().left;
      var _y = $(this).offset().top;
      x = e.pageX - _x - offset[0];
      y = e.pageY - _y - offset[1];

      $('.casefooternew__arrows').css({x: e.pageX - _x, y: e.pageY - _y});
    })

    canvas.on('mouseout.caseFooterNew', function(){
      ishover = false;
      //$('.casefooternew__arrows').removeClass('active');
    })
    /*****/

  }

  componentWillUnmount(){
    if (this.footerImageNode) this.footerImageNode.off('.caseFooterNew');
    if (this.footerApp) {
      this.footerApp.loader.reset();
      this.footerApp.destroy(true, { children: true, texture: true, baseTexture: true });
      this.footerApp = null;
    }
  }

   href = window.location.pathname.split("/")[2]


   next = function () {

    if(!window.location.pathname.includes("projects-new")) return false
    
    var nextValue = []
    var tempArr = data.data.filter((item) => item.category.includes(this.href))
    var indexArr = 0
    tempArr.forEach((element, index) => { if (element.url.includes(window.location.pathname.split("/")[3]) ) { 
      var tempIndex = 1
      if( index === tempArr.length - 1){
        tempIndex = 1
      }else{
        if(tempArr[index + 1].url.includes("marketing")){
          tempIndex  = 2
        }
      }
      nextValue = tempArr[index +  tempIndex ]; indexArr = index + tempIndex;  } });
    var obj = Object.assign({}, nextValue)

    if(indexArr === undefined){
      nextValue = data.data[0]
      obj = Object.assign({}, nextValue)
      obj.url = `/projects-new/${this.href}${tempArr[0].url}`
    }else{
      if(indexArr == tempArr.length){
        obj = tempArr[0]
        obj.url = `/projects-new/${this.href}${tempArr[0].url}`
      }else{
        obj.url = `/projects-new/${this.href}${tempArr[indexArr].url}`
      }

    }
    return obj
  }
  nextArr = this.next()

  render(){

    return(
      <Link to={this.nextArr.url ? this.nextArr.url : this.props.to} className="casefooternew">
        <div className="casefooternew__subtitle">Следующая работа</div>
        <div className="casefooternew__title">{this.nextArr.name ? this.nextArr.name : this.props.title}</div>
        <div className="casefooternew__progress"></div>
        <div className="casefooternew__img" id="page-wrap" ref={this.footerImage}>
          <div className="casefooternew__arrows" />
          <div className="casefooternew__conv" ref={this.footerCanvas} />
        </div>
      </Link>
    )
  }
}

export default withRouter(CaseFooterNew);
